<!-- 库存列表 -->
<template>
    <div class='content'>
        <div class="member_list">
            <div class="table">
                <el-table :data="tableData" border style="width: 100%" :empty-text="language['暂无数据'][LT]">
                    <el-table-column type="index" align="center" label="ID" width="180"></el-table-column>
                    <el-table-column prop="name" align="center" :label="language['商品'][LT]" ></el-table-column>
                    <el-table-column prop="stock" align="center" :label="language['库存'][LT]"></el-table-column>
                    <el-table-column prop="price" align="center" :label="language['价格'][LT]"></el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                        :total="total"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import language from '../../static/i18n/zh';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            keyword: '',
            tableData: [],
            addMemberShow: false,
            rechargeShow: false,
            mobile: '', //会员手机号
            name: '', //会员名称
            money: '', //充值金额
            keyword: '', //搜索内容
            page: 1, //当前页数
            total:0,
            input:'',
            typeNum:1,//弹窗标题
            memberDetails:{},//会员信息
            textarea:'',//备注
            rechargeType:'1',//充值类型 1=增加，2=减少
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        cutPopp(){
            this.money = '';
            this.textarea = '';
            this.rechargeType = '1';
            this.rechargeShow = false
        },
        userChange(item,type){
            console.log(item);
            this.memberDetails = item
            this.typeNum = type

            // type 1充值 2编辑 3删除 4消费记录
            if(type == 1 || type == 2){
                this.rechargeShow = true
            }else if (type == 3) {// 删除会员
                this.$confirm('此操作将删除会员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$post('64e6fbc875578', {id: this.memberDetails.id}).then(res => {
                        if (res.code == 1) {
                            this.page = 1;
                            this.getMemberList();
                        }else{
                            this.$message.info(res.msg)
                        }
                })

            })
            } else if(type == 4) {
                this.$router.push({ path: `/consumptionRecords?id=${item.id}` })
            }
        },
        // 关闭弹窗
        closeChange(){
            this.addMemberShow = false;
            this.mobile = '';
            this.name = '';
            this.money = '';
        },
        // 切换分页
        getChange(event) {
            this.page = event;
            this.tableData = [];
            this.getMemberList();
        },
        // 会员列表
        getMemberList() {
            this.$post('65a630f1c51d3', { keyword: this.keyword, page: this.page }).then(res => {
                if (res.code == 1) {
                    console.log('库存列表', res);
                    this.tableData = res.data.data
                }
            })
        },
        // 添加会员
        addRecharge() {
            if (this.mobile == '') {
                return this.$message.error('请输入会员手机号');
            }
            if (this.name == '') {
                return this.$message.error('请输入会员名称');
            }
            if (this.money == '') {
                return this.$message.error('请输入充值金额');
            }
            this.$post('64d5959d8ae46', { mobile: this.mobile, name: this.name, money: this.money }).then(res => {
                if (res.code == 1) {
                    this.page = 1;
                    this.closeChange()
                    this.getMemberList();
                }else{
                    this.$message.info(res.msg)
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getMemberList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.mobileNum = this.$route.query.mobile;
        if(this.mobileNum){
            this.$post('64e80f2aa504c', { mobile: this.mobileNum }).then(res => {
                if (res.code == 1 && res.data.id) {
                    // console.log('会员详情', res);
                    this.userChange(res.data,1)
                }
            })
        }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    /* height: 100vh; */
    padding: 20px;
    box-sizing: border-box;
}

.member_list {
    background: #fff;
    padding: 15px;

}

.member_tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.member_green {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.member_green div {
    margin-right: 10px;
    min-width: 100px;
}

.inputs {
    margin-right: 100px;
}

.table {
    margin-top: 20px;
}

.page {
    text-align: center;
    margin-top: 40px;
}

.add_member {}

.input_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
}

.red {
    font-size: 20px;
    color: red;
}

.input_content {
    width: 60%;
}

.input_tips {
    max-width: 200px;
    display: flex;
    align-items: center;
    width: 90px;
}

.btns {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/repertoryList.vue